<div class="content-wrapper">
  <div class="ps-3 mt-0 flex items-center">
    <div class="pe-3">
      <!--      <app-avatar [firstName]="firstName" [lastName]="lastName"></app-avatar>-->
    </div>
    <div class="flex flex-row w-full justify-between items-center w-full">
      <div class="flex flex-col w-[50%]">
        <div class="flex flex-wrap items-center gap-2 w-full sm:flex-nowrap">
        <span class="text-gray-600 text-xl font-semibold whitespace-nowrap max-w-full !text-[17px]">
          {{ title }}
        </span>
          <!-- Favorite Icon -->
          @if (isFavIconVisible) {
            <i
              class="pi hide-for-pdf"
              [ngClass]="isFavorite ? 'pi-star-fill text-primary' : 'pi-star text-gray-400'"
              (click)="toggleFavorite()"
              style="cursor: pointer;"
              pTooltip="{{ isFavorite ? 'Remove from favorites' : 'Add to favorites' }}"
              tooltipPosition="top"
            ></i>
          }

          <!-- View Video Button -->
          @if (isVideoVisible && videoUrl) {
            <p-button
              size="small"
              type="button"
              icon="pi pi-video"
              label="Intro Video"
              class="hide-for-pdf"
              styleClass="p-button-sm p-button-rounded bg-primary border-0 w-[120px] "
              (click)="openVideoModal()"
            ></p-button>
          }

          <!-- Download Resume Button -->
          @if (isResumeVisible && resumeUrl) {
            <a [href]="resumeUrl" download target="_blank">
              <p-button
                size="small"
                type="button"
                icon="pi pi-download"
                label="Resume"
                class="hide-for-pdf"
                styleClass="p-button-sm p-button-rounded bg-primary border-0 w-[100px]"
              ></p-button>
            </a>
          }

          @if (isShareButtonVisible) {
            <p-button
              size="small"
              type="button"
              class="ml-2"
              icon="pi pi-share-alt"
              styleClass="p-button-sm p-button-rounded p-button-secondary"
              (click)="shareDialogVisible = true"
            ></p-button>
          }
        </div>
        <span class="text-gray-600 text-[14px]">({{ id }})</span>
      </div>
      <div>
        @if (solutionAttachments?.length !== 0) {
          <div class="flex items-center gap-2">
            <p-button
              size="small"
              icon="pi pi-download"
              label="Download Attachments"
              styleClass="p-button-sm p-button-rounded bg-primary"
              (onClick)="menu.toggle($event)"
            ></p-button>
            <p-menu class="bg-primary" appendTo="body" #menu [popup]="true" [model]="menuItems"></p-menu>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<p-dialog
  [draggable]="false"
  [(visible)]="videoModalVisible"
  [modal]="true"
  [closable]="true"
  header="Introductory Video"
  *ngIf="videoUrl"
>
  <iframe
    *ngIf="isGoogleDriveUrl(videoUrl)"
    [src]="getSafeEmbedUrl(videoUrl)"
    [style]="{ width: '50vw',height:'50vh' }"
    sandbox="allow-same-origin allow-scripts"
    frameborder="0"
    allowfullscreen
  ></iframe>
</p-dialog>

<p-dialog
  [(visible)]="shareDialogVisible"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [draggable]="false"
  header="Share Via"
  [style]="{ width: '400px' }"
  class="rounded-lg custom-share-dialog"
>
  <div class="flex flex-col">
    <!-- SHARE VIA SECTION -->
    <div class="mt-2">
      <div class="flex items-center gap-4">
        <!-- WhatsApp -->
        <p-button
          size="small"
          icon="pi pi-whatsapp"
          styleClass="bg-green-500 border-0 bg-green-600 text-white text-2xl px-3 py-2 rounded-md"
          pTooltip="Share on WhatsApp"
          tooltipPosition="top"
          [style]="{ fontSize: '1.5rem' }"
          (click)="openWhatsApp()"
        ></p-button>

        <!-- PDF -->
        <p-button
          size="small"
          icon="pi pi-file-pdf"
          styleClass="bg-red-600 border-0 hover:bg-red-700 text-white text-2xl px-3 py-2 rounded-md"
          pTooltip="Download as PDF"
          tooltipPosition="top"
          [style]="{ fontSize: '1.5rem' }"
          (click)="downloadAsPdf()"
        ></p-button>
      </div>
    </div>

    <!-- COPY LINK SECTION -->
    <div>
      <p class="text-sm font-semibold text-gray-700 mb-2">Or Copy Link</p>
      <div class="flex">
        <input
          pInputText
          pSize="small"
          type="text"
          [value]="shareUrl"
          readonly
          class="w-full rounded-none border border-gray-300 focus:outline-none px-3 text-sm"
        />
        <p-button
          size="small"
          type="button"
          [label]="copyButtonLabel"
          styleClass="bg-primary hover:bg-primary-600 h-[36px] border-0 text-white text-sm px-4 rounded-none rounded-r-md"
          (click)="copyLinkToClipboard()"
        ></p-button>
      </div>
    </div>
  </div>
</p-dialog>
